import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Atoms';
import * as Styles from './index.styles';

const { StyledSlider, StyledSlideContainer, StyledScrollContent } = Styles;

export const Slider = ({
    defaultSelected,
    circular,
    slideWidth,
    onChange,
    children,
    ...otherProps
}) => {
    const step = Math.round(100 / slideWidth);
    const range = 2 * step;
    const childrenArray = React.Children.toArray(children).map((child, index) =>
        React.cloneElement(child, { value: child.props.value || index }),
    );
    const maxSelected = childrenArray.length - step;

    const [selected, setSelected] = React.useState(defaultSelected - Math.floor(step / 2));

    const onPrevious = () => {
        let previous = selected - step;
        if (previous < 0) {
            previous = circular ? childrenArray.length - 1 : 0;
        }
        setSelected(previous);
        onChange(previous);
    };

    const onNext = () => {
        let next;
        if (selected === maxSelected && circular) {
            next = 0;
        } else if (selected + step < maxSelected) {
            next = selected + step;
        } else {
            next = maxSelected;
        }
        setSelected(next);
        onChange(next);
    };

    return (
        <StyledSlider {...otherProps}>
            {!Number.isNaN(selected) && !Number.isNaN(range) && (
                <>
                    <Icon onClick={onPrevious} icon={['far', 'chevron-left']} />
                    <StyledScrollContent>
                        {childrenArray.map(child => {
                            const { value } = child.props;
                            const offset = value - selected;
                            const preRender = Math.abs(offset) <= range;
                            let onClickValue = value - Math.floor(step / 2);

                            if (onClickValue < 0) {
                                onClickValue = 0;
                            } else if (onClickValue > maxSelected) {
                                onClickValue = maxSelected;
                            }

                            return (
                                preRender && (
                                    <StyledSlideContainer
                                        key={value}
                                        offset={offset}
                                        width={slideWidth}
                                        onClick={() => setSelected(onClickValue)}
                                    >
                                        {child}
                                    </StyledSlideContainer>
                                )
                            );
                        })}
                    </StyledScrollContent>
                    <Icon onClick={onNext} icon={['far', 'chevron-right']} />
                </>
            )}
        </StyledSlider>
    );
};

Slider.propTypes = {
    children: PropTypes.node.isRequired,
    defaultSelected: PropTypes.number,
    width: PropTypes.string,
    slideWidth: PropTypes.number,
    height: PropTypes.string,
    circular: PropTypes.bool,
    onChange: PropTypes.func,
};

Slider.defaultProps = {
    defaultSelected: 0,
    width: '300px',
    slideWidth: 100,
    height: '300px',
    circular: true,
    onChange: () => null,
};

Slider.Styles = Styles;

export * from './Slide';
